import { ActionTypes } from 'store/constants';
import { cloneDeep, filter } from 'lodash';

const translationPracticeInitial = [];

export const translationPractice = (state = translationPracticeInitial, action) => {
  switch (action.type) {
    case ActionTypes.translationPractice.listTranslationPracticeSuccess:
      return action.payload;
    case ActionTypes.translationPractice.updateTranslationPracticeSuccess:
      return state.map((x) =>
        String(x.id) === String(action.payload?.id) ? { ...x, ...action.payload } : x
      );
    case ActionTypes.translationPractice.deleteTranslationPracticeSuccess: {
      const next = cloneDeep(state);
      return filter(next, (k) => String(k.id) !== String(action.payload.id));
    }
    case ActionTypes.translationPractice.listTranslationPracticeFail:
      return state;
    default:
      return state;
  }
};
